import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Slider from 'react-slick';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaQuoteLeft, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import one from '../../assest/team.png';
import two from '../../assest/teamone.png';
import three from '../../assest/teamtwo.png';

// Custom Arrow Components
const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(200, 16, 46, 0.8)", width: "40px", height: "40px", borderRadius: "50%", zIndex: 1 }}
      onClick={onClick}
    >
      <FaChevronLeft style={{ color: "white", fontSize: "20px" }} />
    </div>
  );
};

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(200, 16, 46, 0.8)", width: "40px", height: "40px", borderRadius: "50%", zIndex: 1 }}
      onClick={onClick}
    >
      <FaChevronRight style={{ color: "white", fontSize: "20px" }} />
    </div>
  );
};

const teamMembers = [
  {
    name: 'Daniel Allen',
    title: 'Financial Planner',
    image: one,
    quote: "Helping clients achieve their financial goals is my passion.",
    social: {
      facebook: '#',
      twitter: '#',
      linkedin: '#'
    }
  },
  {
    name: 'Sarah Johnson',
    title: 'Investment Advisor',
    image: two,
    quote: "Strategic investments today create wealth for tomorrow.",
    social: {
      facebook: '#',
      twitter: '#',
      linkedin: '#'
    }
  },
  {
    name: 'Michael Chen',
    title: 'Tax Specialist',
    image: three,
    quote: "Minimizing tax liabilities while maximizing returns.",
    social: {
      facebook: '#',
      twitter: '#',
      linkedin: '#'
    }
  },
];

const TeamSlider = ({ heading = 'Meet Our Expert Team' }) => {
  const { language } = useSelector((state) => state.language);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const translations = {
    gb: {
      heading: 'Meet Our Expert Team',
      name: 'Daniel Allen',
      title: 'Financial Planner',
    },
    sa: {
      heading: 'تعرف على فريقنا الخبير',
      name: 'دانيال ألين',
      title: 'مخطط مالي',
    },
    fr: {
      heading: 'Rencontrez notre équipe d\'experts',
      name: 'Daniel Allen',
      title: 'Planificateur financier',
    },
    de: {
      heading: 'Lernen Sie unser Expertenteam kennen',
      name: 'Daniel Allen',
      title: 'Finanzplaner',
    },
  };

  const t = translations[language] || translations.gb;

  const settings = {
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 3,
    infinite: true,
    arrows: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          arrows: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          arrows: true
        }
      },
    ],
  };

  return (
    <section className="py-5 bg-light">
      <div className="container px-3 px-lg-4">
        <div className="text-center mb-5">
          <h1 className="fw-bold display-4 display-md-3 display-lg-2 mb-4">
            {t.heading || heading}
            <div className="d-flex justify-content-center mt-3">
              <div className="heading-line bg-danger"></div>
              <div className="heading-line-sm bg-danger mx-2"></div>
              <div className="heading-line bg-danger"></div>
            </div>
          </h1>
          <p className="lead text-muted max-w-800 mx-auto">
            Our dedicated professionals are committed to delivering exceptional service and results.
          </p>
        </div>

        <Slider {...settings} className="team-slider">
          {teamMembers.map((member, index) => (
            <div key={index} className="px-3">
              <div
                className="card position-relative overflow-hidden border-0 shadow-sm card-hover"
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                style={{
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  borderRadius: '10px',
                }}
              >
                {/* Team Image with Glass Overlay */}
                <div className="card-img-container position-relative">
                  <img
                    src={member.image}
                    alt={t.name || member.name}
                    className="card-img-top img-fluid"
                    style={{
                      height: '400px',
                      objectFit: 'cover',
                      transition: 'filter 0.3s ease'
                    }}
                  />

                  {/* Glass Effect Overlay */}
                  <div
                    className={`glass-overlay d-flex flex-column justify-content-center align-items-center ${hoveredIndex === index ? 'visible' : ''
                      }`}
                  >
                    <FaQuoteLeft className="quote-icon mb-3" style={{ color: 'white', fontSize: '2rem' }} />
                    <p className="member-quote text-white text-center px-3">{member.quote}</p>

                    {/* Social Icons */}
                    <div className="social-icons d-flex justify-content-center gap-4 mt-4">
                      <a href={member.social.facebook} className="text-white">
                        <FaFacebookF className="fs-5 icon-hover" />
                      </a>
                      <a href={member.social.twitter} className="text-white">
                        <FaTwitter className="fs-5 icon-hover" />
                      </a>
                      <a href={member.social.linkedin} className="text-white">
                        <FaLinkedinIn className="fs-5 icon-hover" />
                      </a>
                    </div>
                  </div>
                </div>

                {/* Member Info */}
                <div className="card-body text-center bg-white">
                  <h5 className="card-title mb-1 fw-bold">{t.name || member.name}</h5>
                  <small className="text-danger fw-medium">{t.title || member.title}</small>
                </div>
              </div>
            </div>
          ))}
        </Slider>

        {/* Custom Styles */}

        <style jsx>{`
          .max-w-800 {
            max-width: 800px;
          }
          
          .heading-line {
            width: 40px;
            height: 3px;
            background-color: #c8102e;
          }
          
          .heading-line-sm {
            width: 5px;
            height: 3px;
            background-color: #c8102e;
          }
          
          .card-hover {
            transition: all 0.3s ease;
          }
          
          .card-hover:hover {
            transform: translateY(-10px);
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
          }
          
          .icon-hover {
            transition: all 0.3s ease;
          }
          
          .icon-hover:hover {
            transform: scale(1.3);
          }
          
          .card-img-container {
            position: relative;
            overflow: hidden;
          }
          
          .glass-overlay {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(200, 16, 46, 0.7);
            backdrop-filter: blur(5px);
            opacity: 0;
            transition: opacity 0.3s ease;
            padding: 20px;
          }
          
          .glass-overlay.visible {
            opacity: 1;
          }
          
          .member-quote {
            font-style: italic;
            font-size: 0.9rem;
            max-width: 80%;
          }
          
          /* Custom arrow positioning */
          .slick-prev {
            left: -50px;
          }
          
          .slick-next {
            right: -50px;
          }
          
          @media (max-width: 768px) {
            .card-hover:hover {
              transform: none;
            }
            
            .member-quote {
              font-size: 0.8rem;
            }
            
            .slick-prev {
              left: -20px;
            }
            
            .slick-next {
              right: -20px;
            }
          }
        `}</style>

      </div>
    </section>
  );
};

export default TeamSlider;